module.exports = __webpack_public_path__ + "static/media/SocialNetworkApi.053aeb96.png";